import React from 'react'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'
import { Box, Flex, Image, ResponsiveSVG } from 'ui/acro'
import { AlomovesIconSVG } from 'images/latest'
import {
  formatEventDate,
  formatEventTimeRange,
  formatEventLocation
} from 'components_v2/Events/formatEvent'
import {
  openGoogleCalendar,
  openOutlookCalendar,
  downloadICS
} from './eventCalendar'

const Container = styled(Flex)({
  background: 'white',
  flexDirection: 'column',
  gap: '24px',
  padding: '20%',
  '@media (min-width: 480px)': {
    padding: '10% 30%'
  }
})

const EventDetailsSection = styled(Flex)({
  flexDirection: 'column',
  textAlign: 'center'
})

const AddToCalendarSection = styled(Flex)({
  flexDirection: 'column',
  gap: '8px'
})

const Title = styled(Text)({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '18px',
  letterSpacing: '0.352px'
})

const OtherInfoText = styled(Text)({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '130%',
  letterSpacing: '0.48px'
})

const CalendarOption = styled(Flex)({
  fontFamily: 'Proxima-Nova',
  padding: '16px',
  border: '1px solid  #A3A3A3',
  cursor: 'pointer'
})

const EventCalendarContent = ({ event }) => {
  if (!event) return null

  const dateLabel = formatEventDate(event.startAt, event.timezone)
  const timeLabel = formatEventTimeRange(
    event.startAt,
    event.endAt,
    event.timezone
  )
  const locationLabel = formatEventLocation(event)

  return (
    <Container>
      <EventDetailsSection>
        {event.coverUrl ? (
          <Box position='relative' mb={['8px', '10px']}>
            <Image
              src={event.coverUrl}
              objectFit='cover'
              position='absolute'
              top='0'
              left='0'
              style={{ aspectRatio: '16/9' }}
              className='event-image'
            />
          </Box>
        ) : (
          <Box mb={['8px', '10px']} className='no-image'>
            <ResponsiveSVG
              width={['68px', '68px', '130px', '130px']}
              height={['68px', '68px', '130px', '130px']}
              SVG={AlomovesIconSVG}
              className='no-thumbnail'
            />
          </Box>
        )}
        <Title>{event.title}</Title>
        {dateLabel && <OtherInfoText>{dateLabel}</OtherInfoText>}
        {timeLabel && <OtherInfoText>{timeLabel}</OtherInfoText>}
        {locationLabel && <OtherInfoText>{locationLabel}</OtherInfoText>}
      </EventDetailsSection>
      <AddToCalendarSection>
        <Title>Add to Your Calendar</Title>
        <CalendarOption onClick={() => openGoogleCalendar(event)}>
          Google
        </CalendarOption>
        <CalendarOption onClick={() => openOutlookCalendar(event)}>
          Outlook
        </CalendarOption>
        <CalendarOption onClick={() => downloadICS(event)}>iCal</CalendarOption>
      </AddToCalendarSection>
    </Container>
  )
}

export default EventCalendarContent
